import { TCamapign } from '@ads/front-core/interfaces'

export const CAMPAIGN_LIST: TCamapign[] = [
  {
    type: 'RETARGETING',
    company: 'WP Media',
    title: 'Kampania displayowa (ROAS)',
    description:
      'Reklamuj swoje produkty w sieci internet. Nasze algorytmy zoptymalizują kampanię w taki sposób, że będzie przynosiła oczekiwaną przez Ciebie stopę zwrotu.',
    href: '/campaign/create/roas',
    imageUrl: '/img/campaign/create-campaign-roas.png',
  },
  {
    type: 'MAILING_PROSPECTING',
    company: 'WP Media',
    title: 'Kampania mailingowa (retargeting)',
    description:
      'Dotrzyj do użytkowników poczty WPM i o2, którzy odwiedzili Twój serwis. Wyślemy im mailing zawierający reklamowane przez Ciebie produkty. Kampania rozliczana jest za kliknięcia w kreację mailingową.',
    href: '/campaign/create/mailing',
    imageUrl: '/img/campaign/create-campaign-mailing.png',
  },
  {
    type: 'PROSPECTING',
    company: 'WP Media',
    title: 'Prospecting display (CPC)',
    description:
      'Pozyskaj ruch na swoją witrynę. Określ stawkę, jaką chcesz płaci za kliknięcie w reklamę, a nasze algorytmy dotrą do użytkowników potencjalnie zainteresowanych Twoimi produktami.',
    href: '/campaign/create/prospectingcpc',
    imageUrl: '/img/campaign/create-campaign-mc-cpc.png',
  },
]

export enum CreationType {
  BANNER = 'BANNER',
  HTML = 'HTML',
  NATIVE = 'NATIVE',
}

export enum Device {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}

export enum Capping {
  HOUR = 'HOUR',
  DAY = 'DAY',
}

export enum FieldType {
  EMAIL = 'EMAIL',
  ENUM = 'ENUM',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
}

export enum CDPRecordMethod {
  INCLUDE = 'INCLUDE',
  EXCLUDE = 'EXCLUDE',
}

export const FLATFEE_SPECIFICATION_URL = 'https://reklama.wp.pl/strefa-klienta'
